import { FC } from 'react';

import { IconButton } from '@mui/material';

import { ReactComponent as UpIcon } from 'assets/icons/ChevronUp.svg';

import { IIconBtnProps } from './types';

import styles from './UpButton.module.scss';

export const UpButton: FC<IIconBtnProps> = ({ onClick }) => {
  return (
    <IconButton className={styles.upButton} onClick={onClick}>
      <UpIcon />
    </IconButton>
  );
};
